import { takeLatest, select, call, put } from 'redux-saga/effects';
import * as types from '../constants/actionTypes';
import * as proxy from '../api/pharmacyProxyApi';
import * as common from './commonSaga';

//Not using this all methods, since we moved centralized proxy system. Please refer proxySaga.js
export default function* pharmacyProxySaga() {
    yield takeLatest(types.PHARMACY_PROXY_INFO, handle, proxy.getProxiesInfo, 'MBHWeb.Saga.Rx.Proxy.GetProxyInfo');
    yield takeLatest(types.PHARMACY_PROXY_REQUEST, handle, proxy.requestAccess, 'MBHWeb.Saga.Rx.Proxy.RequestProxyAccess');
    yield takeLatest(types.PHARMACY_PROXY_RESEND_REQUEST, handle, proxy.resendRequest, 'MBHWeb.Saga.Rx.Proxy.ResendProxyAccessRequest');
    yield takeLatest(types.PHARMACY_PROXY_REMOVE, handle, proxy.removeAccess, 'MBHWeb.Saga.Rx.Proxy.CancelProxyRequest');
    yield takeLatest(types.PHARMACY_PROXY_APPROVE, handle, proxy.approveRequest, 'MBHWeb.Saga.Rx.Proxy.ApproveProxyRequest');
    yield takeLatest(types.PHARMACY_PROXY_DECLINE, handle, proxy.declineRequest, 'MBHWeb.Saga.Rx.Proxy.DeclineProxyRequest');
    yield takeLatest(types.PHARMACY_PROXY_ACCESS_LIST, handle, proxy.getAccessList, null); // proxy.getAccessList is implemented around proxy.getProxiesInfo
    yield takeLatest(types.PHARMACY_PROXY_GRANT, handle, proxy.grantAccess, 'MBHWeb.Saga.Rx.Proxy.GrantProxyAccess');
    yield takeLatest(types.HEALTH_RECORD_PROXY_REQUEST, handle, proxy.requestHealthRecordAccess, 'MBHWeb.Saga.Rx.Proxy.RequestHealthRecordProxyAccess');
}

function* handle(apiCall, andyliticsLogName, action) {
    try {
        const type = action.type;
        const domainData = yield select((state) => state.domain);
        if (action.success) {            
            if (((type === types.PHARMACY_PROXY_REQUEST || type === types.HEALTH_RECORD_PROXY_REQUEST) && action.data && action.data.Status === 'Approved')
                || type === types.PHARMACY_PROXY_REMOVE) {
                yield put({ type: types.PHARMACY_PROXY_ACCESS_LIST });
                if (type === types.PHARMACY_PROXY_REQUEST) yield put({ type: types.PHARMACY_PROXY_REQUEST_DATA, pData: {} });
                if (type === types.HEALTH_RECORD_PROXY_REQUEST || type === types.PHARMACY_PROXY_REQUEST) {
                    yield put({ type: types.PROXY_REQUEST_DATA, pData: {} });                    
                }
            }
            if (type === types.PHARMACY_PROXY_RESEND_REQUEST ||
                type === types.PHARMACY_PROXY_REMOVE ||
                type === types.PHARMACY_PROXY_APPROVE ||
                type === types.PHARMACY_PROXY_DECLINE) {
                yield put({ type: types.PHARMACY_PROXY_INFO });
            }
        }
        else if (!action.error) {
            //if (type === types.PHARMACY_PROXY_INFO) {
            //    yield put({ type: types.PHARMACY_PROXY_REQUEST, success: true, data: null });
            //}            
            yield call(common.handle, apiCall, domainData.t, andyliticsLogName, action);
        }
    }
    catch (e) {
        //debugger;
        console.error(e);
    }
}
